<script>
  import Tag from './Tag.svelte';
  import { suggestTags } from './tags';
  import selectedTags from './store/selected-tags';

  let field;
  let fieldValue = '';
  let fieldHasFocus = false;
  let currentTag = null;
  let suggestedTags = [];
  let containerPosTop = 0;

  function onFocus() {
    fieldHasFocus = true;
    requestAnimationFrame(() => {
      onViewportChange();
      visualViewport.addEventListener('scroll', onViewportChange);
      visualViewport.addEventListener('resize', onViewportChange);
    });
  }

  function onBlur() {
    fieldHasFocus = false;
    currentTag = null;
    visualViewport.removeEventListener('scroll', onViewportChange);
    visualViewport.removeEventListener('resize', onViewportChange);
  }

  function onViewportChange() {
    containerPosTop = visualViewport.offsetTop;
  }

  async function onInput() {
    let tags = await suggestTags(fieldValue);
    tags = tags.filter((sugg) => !$selectedTags.some((sel) => sel.tag === sugg.tag));
    suggestedTags = tags;
    currentTag = 0;
  }

  function onKeyDown(evt) {
    if (evt.key === 'Escape') {
      field.blur();
    }

    if ((evt.key === 'ArrowDown' || evt.key === 'ArrowUp' || evt.key === 'Tab') && suggestedTags.length > 0) {
      evt.preventDefault();

      let dir;
      if (evt.key === 'Tab') {
        if (evt.shiftKey) {
          dir = -1;
        } else {
          dir = 1;
        }
      } else if (evt.key === 'ArrowUp') {
        dir = -1;
      } else {
        dir = 1;
      }

      if (typeof currentTag === 'number') {
        currentTag += dir;
      } else {
        currentTag = dir > 0 ? 0 : suggestedTags.length - 1;
      }

      if (currentTag >= suggestedTags.length || currentTag < 0) {
        currentTag = null;
      }

      return;
    }

    if (evt.key === 'Enter' || evt.key === ' ') {
      evt.preventDefault();

      if (!fieldValue.trim()) { return; }

      let selectedTag;
      if (typeof currentTag === 'number' && suggestedTags.length > 0) {
        selectedTag = suggestedTags[currentTag];
        if (!selectedTag) {
          console.error('No suggested tag found at index:', currentTag);
          return;
        }
        suggestedTags = suggestedTags.filter((t) => t.tag !== selectedTag.tag);
        currentTag = null;
      } else {
        if ($selectedTags.some((tag) => tag.tag === fieldValue.trim())) {
          // tag already selected
          return;
        }
        selectedTag = { tag: fieldValue.trim() };
      }

      $selectedTags = [...$selectedTags, selectedTag];

      fieldValue = '';
      suggestedTags = [];
    }
  }

  function onClickSuggestedTag(evt) {
    const clickedTag = { tag: evt.target.textContent };
    $selectedTags = [...$selectedTags, clickedTag];
    suggestedTags = suggestedTags.filter((t) => t.tag !== clickedTag.tag);
    if (fieldHasFocus) {
      requestAnimationFrame(() => {
        fieldValue = '';
        suggestedTags = [];
        field.focus();
      });
    }
  }

  function onClickSelectedTag(evt) {
    const clickedTag = { tag: evt.target.textContent };
    $selectedTags = $selectedTags.filter((t) => t.tag !== clickedTag.tag);
    if (fieldHasFocus) {
      requestAnimationFrame(() => {
        field.focus();
      });
    }
  }
</script>

<div
  class="tag-container"
  class:focus={fieldHasFocus}
  style="top: {containerPosTop}px"
>
  {#if $selectedTags.length > 0}
    <div class="tags">
      {#each $selectedTags as tag, index (tag.tag)}
        <Tag name={tag.tag} on:mousedown={onClickSelectedTag} />
      {/each}
    </div>
  {/if}
  <div>
    <input
      type="text"
      autocomplete="off"
      autocapitalize="off"
      class="tag-field"
      placeholder="🏷 add tags"
      bind:this={field}
      bind:value={fieldValue}
      on:focus={onFocus}
      on:blur={onBlur}
      on:input={onInput}
      on:keydown={onKeyDown}
    >
  </div>
  {#if fieldHasFocus && suggestedTags.length > 0}
    <div class="tag-suggestions">
      {#each suggestedTags as tag, index (tag.tag)}
        <Tag name={tag.tag} outline={index === currentTag} on:mousedown={onClickSuggestedTag} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .tag-container {
    display: flex;
    flex-direction: column;
  }

  .tag-container.focus {
    position: fixed;
    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
    padding: 0.5rem;
    background-color: white;
  }

  .tag-field {
    border: none;
    outline: none;
  }

  .tags {
    display: flex;
    flex-flow: row wrap;
    border: 1px solid #999;
    padding: 0.125rem;
    border-radius: 0.25rem;
    margin-bottom: 0.5rem;
  }

  .tag-suggestions {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
    padding: 0.125rem;
    overflow-y: auto;
  }
</style>
